(function() {
    'use strict';
    angular
        .module('MW.CoreStream.ContactTagsList', [
                'MW.CoreStream.ContactManagerTagService',
                'MW.Framework.CoreUserService',
                'MW.Framework.CoreCompanyService',
                'MW.Influencers.AnalyticsService',
                'MW.ContactManager.ContactManagerFlashService',
                'MW.Influencers.IcmDialogService'
         ])
        .directive('contactTagsList',function() {
            return {
                restrict: 'E',
                template: '<div ng-include="getTemplateUrl()"></div>',
                scope: {
                   callbackMethod: '&?',
                   selectedContacts: '=?',
                   searchCriteria: '=?',
                   queryType: '=?',
                   addContactType: '@?',
                   mediaListsSelection: '=?',
                   totalContactsCount: '=?',
                   companyId: '@?'
                },
                controller: ContactTagsListController,
                controllerAs: 'contactTagsListController',
                bindToController: true,
                link: function(scope, element, attrs) {
                    scope.closeTagListDialog = function(){
                        scope.completed = false;
                        element.parents().find('.dialogContent').trigger('reveal:close.reveal');
                    };
                    scope.getTemplateUrl = function(){
                        if(attrs.addContactType && attrs.addContactType === 'import') {
                            return 'icm-web/views/partials/import_contact_tags_list';
                        } else {
                            return 'icm-gaf-legacy/views/contact_manager/partials/contact_tags_list';
                        }
                    };
                }
            };
        })
        .controller('contactTagsListController', [
            'ContactManagerTagService',
            'CoreUserService',
            'CoreCompanyService',
            'AnalyticsService',
            'ContactManagerFlashService',
            'DialogService',
            'DEFAULT_MEDIA_LIST',
            '$q',
            '$translate',
            ContactTagsListController
        ]);

     function ContactTagsListController(
         ContactManagerTagService,
         CoreUserService,
         CoreCompanyService,
         AnalyticsService,
         ContactManagerFlashService,
         DialogService,
         DEFAULT_MEDIA_LIST,
         $q,
         $translate
     ) {
        this.ContactManagerTagService = ContactManagerTagService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.DialogService = DialogService;
        this.selectedContactIds = this.selectedContacts ? Object.keys(this.selectedContacts) : [];
        this.mediaLists = [];
        this.selectedMediaLists = {};
        this.saveDisabled = true;
        //TODO - Remove at some point, since we don't need this list to be here any longer
        this.defaultListName = DEFAULT_MEDIA_LIST + (this.companyId ? this.companyId : CoreCompanyService.getId());
        this.$q = $q;
        this.$translate = $translate;
        this.mediaListManageModalFindTranslation = $translate.instant('icm-media-list__manage-modal--find');
        this.mediaListManageModalAddTranslation = $translate.instant('icm-media-list__manage-modal--add');
        this.importContactFindTranslation = $translate.instant('icm-import-contact__modal--find');
        this.importContactAddTranslation = $translate.instant('icm-import-contact__modal--add');
        this.tagInput = '';

        ContactManagerTagService.getAllTags().then(function(response) {
            this.mediaLists = response;
        }.bind(this));
    }

    ContactTagsListController.prototype.isDuplicateList = function isDuplicateList(tags, tagName) {
        return tags.some(function(value){
            return (value.name && value.name.toLowerCase() === tagName.toLowerCase());
        });
    };

    ContactTagsListController.prototype.toggleSelection = function toggleSelection(mediaListId){
        if(this.selectedMediaLists[mediaListId]){
            delete this.selectedMediaLists[mediaListId];
        } else {
            this.selectedMediaLists[mediaListId] = true;
        }

        this.mediaListsSelection = Object.keys(this.selectedMediaLists);
    };

    ContactTagsListController.prototype.getMediaListIdByName = function getMediaListIdByName(mediaLists, tagName){
        return mediaLists.filter(function(tagListObj) {
                return tagListObj.name.toLowerCase() === tagName.toLowerCase();
            }.bind(this))[0].id;
    };

    ContactTagsListController.prototype.shouldDisableSave = function shouldDisableSave(){
        return (this.ContactManagerTagService.isFetching || this.ContactManagerTagService.isSaving || Object.keys(this.selectedMediaLists).length === 0);
    };

    ContactTagsListController.prototype.createNewTag = function createNewTag(event,tagName){
        var KEY_ENTER = 13;

        if (event.which === KEY_ENTER && tagName !== '' || event === 'createNewSwitch' && tagName){
            if(this.isDuplicateList(this.mediaLists, tagName)) {
                this.selectedMediaLists[this.getMediaListIdByName(this.mediaLists, tagName)] = true;
                this.mediaListsSelection = Object.keys(this.selectedMediaLists);
                this.tagInput = '';
            } else {
                this.ContactManagerTagService.saveMediaList(tagName).then(function(response){
                    this.mediaLists.push(response);
                    this.toggleSelection(response.id);
                    this.tagInput = '';
                }.bind(this));
            }
        }
    };

    ContactTagsListController.prototype.save = function save(){

            this.mediaListsSelection = Object.keys(this.selectedMediaLists);
            if(this.mediaListsSelection.length !== 0){
                this.saveLists(this.selectedMediaLists, this.selectedContactIds);
            } else {
                this.DialogService.closeDialog();
            }
    };

    ContactTagsListController.prototype.saveLists = function saveLists(selectedMediaLists, contactIds) {
        var _this = this,
            _selectedMediaLists = Object.keys(selectedMediaLists),
            contactsCount = contactIds.length,
            tagPromise;

        // determine if we want to add people to the list by a search query, or IDs
        if(this.queryType) {
            tagPromise = this.ContactManagerTagService.updateContactMediaListsWithQuery(this.searchCriteria, _selectedMediaLists, this.queryType);
            contactsCount = this.totalContactsCount;
        } else {
            tagPromise = this.ContactManagerTagService.saveTagWithContact(_selectedMediaLists, contactIds);
        }

        tagPromise
            .then(function(response) {
                if(response && response.data && Array.isArray(response.data.nonContacts) && response.data.nonContacts.length) {
                    var numberOfEmailsToDisplay = 3,
                        nonContactCount = response.data.nonContacts.length,
                        numberNotDisplayed = (nonContactCount - numberOfEmailsToDisplay),
                        nonContactList = response.data.nonContacts
                            .map(function(nonContact) {
                                return nonContact.email;
                            })
                            .slice(0, numberOfEmailsToDisplay)
                            .join(', ');
                    contactsCount = contactsCount - nonContactCount;

                    if(numberNotDisplayed > 0) {
                        this.ContactManagerFlashService.flashWarning(nonContactCount + ' email address(es) not added: ' + nonContactList + ' and ' + numberNotDisplayed + ' other(s)');
                    } else {
                        this.ContactManagerFlashService.flashWarning(nonContactCount + ' email address(es) not added: ' + nonContactList);
                    }

                } else {
                    this.ContactManagerFlashService.flashSuccess('adding-contacts-influencer-list__flash-message--success');
                }

                var selectedMediaListSnippets = [];
                _selectedMediaLists.forEach(function(_selectedMediaListId) {
                    _this.mediaLists.some(function(mediaList) {
                        if(_selectedMediaListId === mediaList.id) {
                            selectedMediaListSnippets.push({
                                key: mediaList.id,
                                name: mediaList.name
                            });

                            return true;
                        }
                    });
                });

                this.trackEvent(_selectedMediaLists, contactsCount);
                this.callbackMethod({contactIds: contactIds, selectedMediaLists: _selectedMediaLists, selectedMediaListSnippets: selectedMediaListSnippets});
                this.DialogService.closeDialog();
            }.bind(this))
            .catch(function() {
                this.ContactManagerFlashService.flashError('Oops. There was a problem adding this contact. Please try again later.');
            }.bind(this));
    };

    ContactTagsListController.prototype.trackEvent = function trackEvent(mediaLists, contactsCount) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function(responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'add_contact',
                contactCount: contactsCount,
                parentType: 'ICM_contact_lists',
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            mediaLists.forEach(function(list) {
                trackingData.mediaListId = list;
                this.AnalyticsService.trackMediaListOperation('add_contact', trackingData);
            }.bind(this));

        }.bind(this));
    };
}());
